import RequestBase from '../Resources/RequestBase';
var rp = require('request-promise');

export default class RequestService {
    constructor(apiKey, accessToken) {
        this._apiKey = apiKey;
        this._accessToken = accessToken;
        this._baseUrl = 'https://api.giphy.com';
    }

    set accessToken(accessToken) {
        this._accessToken = accessToken;
    }

    verifyBody(request) {
        var found = false;
        var bodyParam = {};

        if (request.method === 'GET') { return true; }

        if (request.contentType === 'application/json') {
            bodyParam = request.body;
        }
        if (request.contentType === 'application/x-www-form-urlencoded') {
            request.body.split('&').map((x) => {
                var split = x.split('=');

                bodyParam[split[0]] = split[1];
            });
        }

        request.parameters.forEach(element => {
            if (bodyParam[element] === undefined) { found = true; };
        });

        return !found;
    }

    apiCall(request) {
        var options = {};

        return new Promise((resolve, reject) => {
            if (request instanceof RequestBase &&
                request.Validate() &&
                this.verifyBody(request)) {

                options = {
                    method: request.method,
                    uri: this._baseUrl + request.url,
                    qs: request.qs,
                    body: request.body,
                    headers: {
                        'Content-Type': request.contentType
                        // 'Authorization': 'Bearer ' + this._accessToken
                    },
                    json: true
                };

                rp(options).then((result) => {
                    resolve(result);
                }).catch((error) => {
                    var parsedError = this.parseRequestError(error);

                    reject(parsedError);
                });
            }
        });
    }

    parseRequestError(error) {
        return {
            statusCode: error.response.statusCode,
            statusMessage: error.response.statusMessage,
            body: error.response.body.message
        };
    }
}



// WEBPACK FOOTER //
// ./src/Utils/RequestService.js